import styled, {ThemeProps} from 'styled-components';
import {CenteredSpaceWrap} from '../../../CommonStyleUtils/dwebCommon.styles';
import {Theme} from './../../../../theme/types';

import Image from '@stencil/image';

import {Column, Row} from './../../common/Layouts/Layouts';

export const ContentWrapperDiv = styled.div(
  props => `
  margin: 0 auto;
  max-width: 120rem;
  padding-top: ${props.theme.spacing.large};
  background-color: ${props.theme.colors.goBrandBlue.light};
`,
);

export const OuterWrapperDiv = styled.div(
  props => `
  background-color: white;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
`,
);

export const HeadingWrapperDiv = styled(CenteredSpaceWrap)(
  props => `
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
`,
);

export const DropDownTextWrapper = styled.span(
  (props: ThemeProps<Theme>) => `
  color: ${props.theme.colors.downriver.medium};
  font-size: ${props.theme.font.custom(14)};
`,
);

export const DropDownDefaultValueWrapper = styled.span(
  (props: ThemeProps<Theme>) => `
font-size: ${props.theme.font.custom(14)};
font-weight: bold;
padding-left: ${props.theme.spacing.base};
`,
);

export const FilterCategoryWrapperDiv = styled.div(
  props => `
  padding-left: ${props.theme.spacing.large};
`,
);

export const ReviewByUserWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding: ${props.theme.spacing.xlarge};
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
`,
);

export const UserReviewOuterWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding: ${props.theme.spacing.xlarge};
`,
);

export const AllReviewBtnDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding-top:${props.theme.spacing.xxlarge};
  padding-bottom:${props.theme.spacing.xxlarge};

  justify-content: center;

`,
);

export const AllReviewWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-top:${props.theme.spacing.xlarge};
  width:100%;
  background-color: ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.large};

`,
);

export const TripAdvisorImage = styled(Image)(
  props => `
    display: flex;
    width: 14.5rem
    height: 2.2rem;

`,
);

export const SeeAllLink = styled.a(
  props => `
  display:inline-flex;
  cursor: pointer;
  font-size:${props.theme.font.large};
  padding-right:${props.theme.spacing.base};
  font-family:${props.theme.font.fontFamily};
  font-weight:bold;

  color: ${props.theme.colors.goBrandBlue.base};
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base};
  }
`,
);
